import InventoryItem from 'src/models/inventory-item/InventoryItem'
import InventoryRecipe from 'src/models/inventory-recipe/InventoryRecipe'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'

export default class InventoryRecipeItem extends Model {
  static name = 'InventoryRecipeItem'

  static versioned = true

  static deletable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String,
        output: true
      },
      inventoryItem: {
        type: InventoryItem,
        encode: encoders.hasOne,
        reference: true
      },
      inventoryRecipe: {
        type: InventoryRecipe,
        output: true,
        excludeFromDefault: true
      },
      baseQuantity: {
        type: Number
      }
    }
  }
}
